import { useMemo } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { userOptionsStore } from '~/shared/api'
import {
  documentsCodeEnumOptions,
  reasonsTerminationsOptions,
} from '~/shared/config/constants'
import { DocumentsTypeEnum } from '~/shared/config/enums'
import { Button } from '~/shared/ui/Buttons'
import { Checkbox, DrawerSelectMultiple, FormProvider } from '~/shared/ui/form'
import { TextareaInput } from '~/shared/ui/form/TextareaInput'
import { FormHeader } from '../FormHeader'
import { CheckBoxListWrapper, Wrapper } from './styled'
import { DocumentsFormValues } from './types'

type DocumentsFormProps = {
  onSuccess: () => void
  form: UseFormReturn<DocumentsFormValues>
  submitTitle: string
  isSubmitting: boolean
  isRefund?: boolean
}

export function DocumentsForm({
  onSuccess,
  form,
  submitTitle,
  isSubmitting,
  isRefund,
}: DocumentsFormProps) {
  const { t } = useTranslation()

  const availableDocumentTypes = userOptionsStore.documentTypes

  const visibleDocumentsOptions = useMemo(
    () =>
      documentsCodeEnumOptions.filter(({ id }) =>
        availableDocumentTypes
          ? availableDocumentTypes.includes(id)
          : id !== DocumentsTypeEnum.PATENT,
      ),
    [availableDocumentTypes],
  )

  const translateReasonsTerminationsOptions = useMemo(
    () =>
      reasonsTerminationsOptions.map((reason) => ({
        ...reason,
        id: t(reason.id),
      })),
    [t],
  )

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <Wrapper>
        <CheckBoxListWrapper>
          {visibleDocumentsOptions.map((param) => (
            <Checkbox
              key={param.id}
              labelI18n={param.label}
              name={`documents.${param.id}`}
            />
          ))}
        </CheckBoxListWrapper>

        <FormHeader title='form.comment' />

        <TextareaInput
          name='comment'
          rows={6}
          style={{ marginBottom: '12px' }}
        />

        {isRefund && (
          <>
            <FormHeader title='form.contract termination' />
            <DrawerSelectMultiple
              label='form.reasons for termination'
              name='refundReasons'
              title='form.reasons for termination'
              options={translateReasonsTerminationsOptions}
              validation={{
                required: 'validate.required field',
              }}
            />

            <Checkbox
              labelI18n='form.car is ready for rent'
              name='isCarReadyForRent'
              style={{ margin: '12px 0' }}
            />
          </>
        )}

        <Button
          fullWidth
          type='submit'
          variant='limeFlooded'
          uppercase
          style={{ marginTop: '16px' }}
          loading={isSubmitting}
        >
          {submitTitle}
        </Button>
      </Wrapper>
    </FormProvider>
  )
}
